<template>
  <div class="sales-suppliers">
    <b-card>
      <b-card-header class="d-flex justify-content-between align-items-center">
        <h4 class="mb-0">
          <feather-icon
            icon="UsersIcon"
            size="20"
            class="mr-1"
          />
          Mes Fournisseurs Attribués
        </h4>
        <b-button
          variant="outline-primary"
          size="sm"
          :disabled="loading"
          @click="loadSuppliers"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="14"
            :class="{ 'spinning': loading }"
          />
          Actualiser
        </b-button>
      </b-card-header>

      <b-card-body>
        <div
          v-if="loading"
          class="text-center py-5"
        >
          <b-spinner variant="primary" />
          <p class="mt-2 text-muted">
            Chargement des fournisseurs...
          </p>
        </div>

        <div
          v-else-if="suppliers.length === 0"
          class="text-center py-5"
        >
          <feather-icon
            icon="InboxIcon"
            size="48"
            class="text-muted"
          />
          <p class="mt-2 text-muted">
            Aucun fournisseur attribué
          </p>
        </div>

        <b-table
          v-else
          :items="suppliers"
          :fields="fields"
          responsive
          hover
          show-empty
          class="mb-0"
        >
          <template #cell(supplier_name)="data">
            <div>
              <span class="font-weight-bold">{{ data.item.supplier_name }}</span>
              <br>
              <small class="text-muted">{{ data.item.supplier_email }}</small>
            </div>
          </template>

          <template #cell(supplier_phone)="data">
            <span>{{ data.item.supplier_phone }}</span>
          </template>

          <template #cell(start_date)="data">
            {{ formatDate(data.item.start_date) }}
          </template>

          <template #cell(is_active)="data">
            <b-badge :variant="data.item.is_active ? 'success' : 'secondary'">
              {{ data.item.is_active ? 'Actif' : 'Inactif' }}
            </b-badge>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BButton,
  BSpinner,
  BBadge,
} from 'bootstrap-vue'

export default {
  name: 'SalesSuppliers',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
    BSpinner,
    BBadge,
  },
  data() {
    return {
      loading: false,
      suppliers: [],
      fields: [
        { key: 'supplier_name', label: 'Fournisseur' },
        { key: 'supplier_phone', label: 'Téléphone' },
        { key: 'start_date', label: 'Attribué depuis' },
        { key: 'is_active', label: 'Statut', class: 'text-center' },
      ],
    }
  },
  mounted() {
    this.loadSuppliers()
  },
  methods: {
    async loadSuppliers() {
      this.loading = true
      try {
        const response = await axios.get('/api/commissions/supplier-attributions/', {
          params: { active_only: 'true' },
        })
        this.suppliers = response.data.results || response.data
      } catch (error) {
        console.error('Error loading suppliers:', error)
        this.$bvToast.toast('Erreur lors du chargement des fournisseurs', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    },
  },
}
</script>

<style scoped>
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
